var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import ConsentMandate from "./MandateDetails/ConsentMandate";
import Platforms from "./Platforms";
import Segment from "./Segment";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "../../../../../../shared-library/components/Loader";
var PlatformsSegmentsBlock = function () {
    var _a = __read(React.useState(), 2), platFormSegmentData = _a[0], setplatFormSegmentData = _a[1];
    var _b = __read(React.useState(), 2), consentData = _b[0], setConsentData = _b[1];
    var _c = __read(React.useState(false), 2), loader = _c[0], setLoader = _c[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    function getplatFormData() {
        setLoader(true);
        di.clients
            .getPlatformsDetailsData({
            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
        })
            .then(function (resp) {
            setplatFormSegmentData(resp);
            setLoader(false);
        })
            .catch(function (error) {
            setplatFormSegmentData({});
            setLoader(false);
        });
    }
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) {
            getplatFormData();
            //  getConsentData();
        }
    }, [selectedAcount.accountCode]);
    return (React.createElement(React.Fragment, null, loader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
        React.createElement(Platforms, { data: platFormSegmentData }),
        React.createElement(Segment, { data: platFormSegmentData }),
        platFormSegmentData && (React.createElement(ConsentMandate, { data: platFormSegmentData, smtfDetails: consentData }))))));
};
export default PlatformsSegmentsBlock;
